import { Box, Card, CardBody, Container } from '@chakra-ui/react'
import type { ReactNode } from 'react'

interface CsatPublicLayoutProps {
  children: ReactNode
}

export function CsatPublicLayout({ children }: CsatPublicLayoutProps) {
  return (
    <Box minH="100vh" display="flex" alignItems="center" justifyContent="center" bg="gray.50" p={4}>
      <Container maxW="480px" p={0}>
        <Card shadow="lg" w="100%">
          <CardBody p={{ base: 6, md: 8 }}>{children}</CardBody>
        </Card>
      </Container>
    </Box>
  )
}
